import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "@reducers/productReducer";
import { actions as leaderActions } from "@reducers/leaderReducer";
import { actions as orderActions } from "@reducers/orderReducer";
import { actions as categoryActions } from "@reducers/categoriesReducer";

const RefreshAndFocusHandler = (WrappedComponent) => {
  return function (props) {
    const [isPulled, setIsPulled] = useState(false);
    const {
      isFetchingProducts,
      isFetchingUsers,
      isFetchingOrders,
      isFetchingOffers,
    } = useSelector(
      ({
        products: { isFetchingProducts },
        leader: { isFetchingUsers, isFetchingOffers },
        orders: { loading },
      }) => ({
        isFetchingProducts,
        isFetchingUsers,
        isFetchingOrders: loading,
        isFetchingOffers,
      }),
    );

    const listener = useRef(null);
    const currentRoute = useRef("");

    const dispatch = useDispatch();

    const fetchProducts = (payload) => {
      dispatch(actions.getProductRequest(payload));
      dispatch(categoryActions.getAllCategories());
    };

    const fetchUsers = (payload) => {
      dispatch(leaderActions.getAllUsers(payload));
    };

    const fetchOrders = (payload) => {
      dispatch(orderActions.getAllOrdersReq(payload));
    };

    const fetchOffers = (payload = {}) => {
      dispatch(categoryActions.getAllCategories());
    };

    function didFocus(event = null, isListPulled = false) {
      const { state } = props.navigation;

      // if (!state.params || state.params.refreshScreen === undefined) return;

      const currentRouteName = currentRoute.current;

      let payload = {};

      if (isListPulled) {
        setIsPulled(true);
      }

      // delete state.params.refreshScreen;

      if (currentRouteName) {
        switch (currentRouteName) {
          case "Catalogue":
            {
              payload = {
                catName: "hot-deals",
                offsetValue: 0,
                limit: 10,
                fromScreen: "Catalogue",
                category: {},
                replace: true,
                isPulled: isListPulled,
              };

              fetchProducts(payload);
            }
            break;

          case "Customers":
            {
              payload = {
                offset: 0,
                limit: 10,
                replace: true,
                isPulled: isListPulled,
              };

              fetchUsers(payload);
            }
            break;

          case "Orders":
            {
              payload = {
                offset: this.offset,
                limit: this.limit,
                replace: true,
                isPulled: isListPulled,
              };

              fetchOrders(payload);
            }
            break;

          case "Home": {
            fetchOffers();
          }
        }
      }
    }

    useEffect(() => {
      if (currentRoute.current) {
        let loading;

        switch (currentRoute.current) {
          case "Catalogue":
            {
              loading = isFetchingProducts;
            }
            break;

          case "Customers":
            {
              loading = isFetchingUsers;
            }
            break;

          case "Orders":
            {
              loading = isFetchingOrders;
            }
            break;

          case "Home":
            {
              loading = isFetchingOffers;
            }
            break;
        }

        if (!loading) {
          setIsPulled(false);
        }
      }
    }, [
      isFetchingProducts,
      isFetchingUsers,
      isFetchingOrders,
      isFetchingOffers,
    ]);

    useEffect(() => {
      currentRoute.current = props.route.name;

      listener.current = props.navigation.addListener("didFocus", function (e) {
        didFocus(e, false);
      });

      return () => {
        if (listener.current && listener.current) {
          listener.current();
        }
      };
    }, []);

    return (
      <WrappedComponent {...props} pulledFunc={didFocus} isPulled={isPulled} />
    );
  };
};

export default RefreshAndFocusHandler;
